module.exports = __webpack_public_path__ + "static/media/cars.b4e35084.png";